<template>
    <div>
        中转
    </div>
</template>


<script setup>
import { ref, onMounted,onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const isMobile = ref(false)

const checkDevice = () => {
  isMobile.value = window.innerWidth < 768
}

const goToHome = () => {
  if(isMobile.value){
    router.push('/mobileSystemManage')
    console.log('手机端')
  }else{
    router.push('/houseCart')
    console.log('pc端')
  }
}

onMounted(() => {
  checkDevice()
  window.addEventListener('resize', checkDevice)
  goToHome()
})

// 清理事件监听器
onUnmounted(() => {
  window.removeEventListener('resize', checkDevice)
})
</script>